import React from 'react'
import { APIClient } from '@/services'
import { Organisation } from '@/features'
import { ScoresContext } from './context'
import { View } from '@/components'

export const IndustryScoreOverview = () => {
  const { industry } = ScoresContext.useIndustrySelector()

  const profileIndustry = ScoresContext.useScoresContext(
    c => c.profile?.data?.organization?.category?.slug
  )

  const scoreModal = Organisation.useScoreModal(false)

  const industryQuery = APIClient.Organisations.useIndustry(industry)

  return (
    <>
      <View variants={['column', 'gap:2', 'alignCenter', 'fullWidth']}>
        <Organisation.ScoreHeader />
        <Organisation.PerTopicEngagementScore
          industry={industryQuery.industry}
          onExpand={topic => {
            scoreModal.toggle(true, {
              topicId: topic?.value,
            })
          }}
        />
        <Organisation.OrgReviewButtons isMyOrganisation={profileIndustry === industry} />
      </View>
      <Organisation.ScoreModal
        visible={scoreModal.visible}
        toggle={scoreModal.toggle}
        industryId={industry}
        topicId={scoreModal.props.topicId}
      />
    </>
  )
}
